import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  soldoutCustomPageListPath,
  SoldoutCustomPageListUrlQueryParams
} from "./urls";
import SoldoutCustomPageListComponent from "./views/SoldoutcustompageList";

const SoldoutCustomPageList: React.FC<RouteComponentProps<{}>> = ({
  location
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: SoldoutCustomPageListUrlQueryParams = { ...qs };
  return <SoldoutCustomPageListComponent params={params} />;
};

// export const SoldoutCustomPageSectio: React.FC = () => {
const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.soldoutcustompage)} />
      <Switch>
        <Route
          exact
          path={soldoutCustomPageListPath}
          component={SoldoutCustomPageList}
        />
      </Switch>
    </>
  );
};

export default Component;
